import App from '@/models/App'

export default class OrderingOrdererAccount extends App {
    static get entity() {
        return 'OrderingOrdererAccounts'
    }

    static all() {
        return this.query().with('user').get()
    }

    static fields() {
        return {
            id: this.attr(''),
            userId: this.attr(''),
            organizationId: this.attr(''),
            type: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            user: this.attr({}), // FIXME
        }
    }

    static apiConfig = {
        actions: {
            fetch(orderingShipId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/accounts`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            searchForReceiver(orderingShipId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/accounts/searchForReceiver`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingShipId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/accounts`,
                    App.post(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingShipId, orderingAccountId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/accounts/${orderingAccountId}`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingAccountId) {
                return this.delete(
                    `/ordering/orderer/${orderingShipId}/accounts/${orderingAccountId}`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingAccountId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
